export default __webpack_public_path__ + "static/media/G2ESS_150.bcb9b473.jpg";